import { connect } from 'react-redux'
import * as action from '../../state/file-upload/action'
import * as customerAction from '../../state/detail/action'
import * as selector from '../../state/file-upload/selector'
import CustomerFileUpload from './CustomerFileUpload'
import { FILE_TYPE_SCAN_FILE } from '../../state/const'
import { SCAN_FILE_UPLOAD_WIDGET } from '../../../process/ui-definition/process-ui'


const mapStateToProps = state => {
    return {
        ...selector.selectOwnState(state),
        fetching: selector.selectIsFetching(state, FILE_TYPE_SCAN_FILE),
        fileType: FILE_TYPE_SCAN_FILE,
        widgetId: SCAN_FILE_UPLOAD_WIDGET,
    }
}

const mapDispatchToProps = {
    uploadCustomerFile: action.uploadCustomerFile,
    setDeleteFlag: action.setDeleteFlag,
    onUploadSuccess: customerAction.addCustomerFile,
    onFileDeleteFlagSuccess: customerAction.onFileDeleteFlagSuccess,
}


export default connect(mapStateToProps, mapDispatchToProps)(CustomerFileUpload)



// WEBPACK FOOTER //
// ./src/modules/customer/component/scan-file-upload/ScanFileUploadContainer.js